// import  { useEffect, useRef, useState, useMemo, useCallback } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchDonors, deleteDonor } from "../../redux/donorSlice";
// import { AgGridReact } from "ag-grid-react";
// import "ag-grid-community/styles/ag-grid.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
// import { IconButton, Button } from "@mui/material";
// import { filterDonors } from "./utils/DonorUtils";
// import { getHeaderClass } from "../../utils/agGridHelpers";
// import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
// import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
// import DifferenceIcon from '@mui/icons-material/Difference';
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import HistoryIcon from "@mui/icons-material/History";
// import Filter from "../Filter";
// import AgGridLoader from "../AgGridLoader";
// import ConfirmationDialog from "../ConfirmationDialog";
// import AlertMessage from "../AlertMessage";
// import { fetchDonation } from "../../redux/donationSlice";
// import { getSystemFormattedTimestamp } from "../../utils/dateFormatted";
// import { clearAllFilters } from "../../utils/agGridHelpers";
// import { logger } from "../../utils/logger";
// import SnackBarAlert from "../SnackBarAlert";
// import HistoryModal from "../HistoryModal";
// import ComparisonSelectedModal from "../DonorMerge/ComparisonSelectedModal";
// import CompareDonorsDialog from "../DonorMerge/CompareDonorsDialog";
// import ManualMergeDialog from "../DonorMerge/ManualMergeDialog";
// import { mergeDonors, clearMergeResult, resetMergeState } from "../../redux/donorMergeSlice";
// import {
//   updateLocalPreferences,
//   saveTablePreferences,
//   loadTablePreferences,
// } from "../../redux/tablePreferenceSlice";
// import { DEFAULT_DONOR_COLUMNS } from "../../config/donorTableColumns";

// const DonorList = ({ onEdit, openDonorForm }) => {
//   const dispatch = useDispatch();
//   const { donors, loading } = useSelector((state) => state.donor || {});
//   const { role } = useSelector((state) => state.auth || "user");
//   const { user } = useSelector((state) => state.auth);
//   const { donations } = useSelector((state) => state.donation || {});
//   const { loading: mergeLoading, mergeResult } = useSelector((state) => state.donorMerge || {});
//   const [selectedDonor, setSelectedDonor] = useState(null);
//   const [openConfirm, setOpenConfirm] = useState(false);
//   const [selectedDonorHasDonations, setSelectedDonorHasDonations] =
//     useState(false);
//   const [alertMessageOpen, setAlertMessageOpen] = useState(false);
//   const [gridReady, setGridReady] = useState(false);
//   const [isFirstLoad, setIsFirstLoad] = useState(true);
//   const gridRef = useRef(null);
//   const gridApiRef = useRef(null);
//   const columnApiRef = useRef(null);
//   const lastKnownColumnStateRef = useRef(null);
//   const isInitializingRef = useRef(false);
//   const debounceTimeoutRef = useRef(null);
//   const [initialFetchDone, setInitialFetchDone] = useState(false);
//   const [feedback, setFeedback] = useState({
//     open: false,
//     message: "",
//     severity: "info",
//   });
//   const [historyModalOpen, setHistoryModalOpen] = useState(false);
//   const [selectedHistory, setSelectedHistory] = useState([]);
//   const [selectedDonorId, setSelectedDonorId] = useState(null);
//   const [filterValues, setFilterValues] = useState({});
//   const [hasAppliedInitialState, setHasAppliedInitialState] = useState(false);
//   const userIsInteractingRef = useRef(false);

//   // Donor merge states
//   const [comparisonModalOpen, setComparisonModalOpen] = useState(false);
//   const [compareDialogOpen, setCompareDialogOpen] = useState(false);
//   const [mergeResultModalOpen, setMergeResultModalOpen] = useState(false);
//   const [sourceDonorForMerge, setSourceDonorForMerge] = useState(null);
//   const [targetDonorForMerge, setTargetDonorForMerge] = useState(null);

//   const filteredDonors = useMemo(
//     () => filterDonors(donors, filterValues),
//     [donors, filterValues]
//   );

//   // Cleanup debounce timeout on unmount
//   useEffect(() => {
//     return () => {
//       if (debounceTimeoutRef.current) {
//         clearTimeout(debounceTimeoutRef.current);
//       }
//     };
//   }, []);
//   const tableId = "donorTable";
//   const tableState = useSelector(
//     (state) => state.tablePreference?.tables?.[tableId]
//   );

//   // Load preferences from backend on component mount
//   useEffect(() => {
//     dispatch(
//       loadTablePreferences({ tableId, defaultColumns: DEFAULT_DONOR_COLUMNS })
//     );
//   }, [dispatch, tableId]);

//   // Apply column state once both grid is ready and preferences are loaded
//   useEffect(() => {
//     if (!gridReady || !gridRef.current?.api || hasAppliedInitialState) {
//       return;
//     }

//     // Wait for preferences to finish loading
//     if (tableState?.loading) {
//       return;
//     }

//     // Set flag to prevent handleColumnChange from firing during initialization
//     isInitializingRef.current = true;

//     try {
//       const savedState = tableState?.columns;

//       if (savedState && Array.isArray(savedState) && savedState.length > 0) {
//         gridRef.current.api.applyColumnState({
//           state: savedState,
//           applyOrder: true,
//         });
//         // Update the last known state to prevent unnecessary saves
//         lastKnownColumnStateRef.current = [...savedState];
//       } else {
//         // Apply default column order and save it
//         gridRef.current.api.applyColumnState({
//           state: DEFAULT_DONOR_COLUMNS,
//           applyOrder: true,
//         });
//         // Update the last known state
//         lastKnownColumnStateRef.current = [...DEFAULT_DONOR_COLUMNS];
//         // Save default columns after applying them
//         setTimeout(() => saveDefaultColumnsWithApi(columnApiRef.current), 500);
//       }

//       // Mark that we've applied the initial state
//       setHasAppliedInitialState(true);
//     } catch (error) {
//       console.error("Error applying column state:", error);
//     }

//     // Clear the initialization flag after a delay
//     setTimeout(() => {
//       isInitializingRef.current = false;
//     }, 500);
//   }, [
//     gridReady,
//     tableState?.columns,
//     tableState?.loading,
//     hasAppliedInitialState,
//   ]);

//   useEffect(() => {
//     if (!gridReady) return;

//     const fetchAll = async () => {
//       if (!donors || donors.length === 0) {
//         dispatch(fetchDonors());
//         setInitialFetchDone(true);
//         if (!donations || donations.length === 0) {
//           dispatch(fetchDonation());
//         }
//       }
//     };

//     fetchAll();
//   }, [dispatch, gridReady]);

//   const onGridReady = (params) => {
//     if (!params || !params.api) {
//       console.error("Grid params or api is undefined");
//       setGridReady(true);
//       return;
//     }

//     // Set flag to prevent handleColumnChange from firing during initialization
//     isInitializingRef.current = true;

//     gridRef.current = params;
//     gridApiRef.current = params.api;
//     columnApiRef.current = params.columnApi || params.api;
//     setGridReady(true);

//     setTimeout(() => {
//       isInitializingRef.current = false;
//     }, 1000);
//   };

//   const deriveStateFromGridApi = () => {
//     try {
//       if (!gridApiRef.current) {
//         console.warn("deriveStateFromGridApi: gridApiRef.current is null");
//         return null;
//       }

//       // Try to get column state directly first
//       if (gridApiRef.current.getColumnState) {
//         try {
//           const state = gridApiRef.current.getColumnState();
//           return state;
//         } catch (err) {
//           console.warn("deriveStateFromGridApi: getColumnState failed:", err);
//         }
//       }

//       // Fallback: derive from getAllColumns
//       if (gridApiRef.current.getAllColumns) {
//         const cols = gridApiRef.current.getAllColumns();
//         if (!cols) {
//           console.warn("deriveStateFromGridApi: getAllColumns returned null");
//           return null;
//         }

//         const derivedState = cols.map((c) => ({
//           colId: c.getColId(),
//           hide: !c.isVisible(),
//           width: c.getActualWidth(),
//           pinned: c.getPinned ? c.getPinned() : null,
//           sort: c.getSort ? c.getSort() : null,
//           sortIndex: c.getSortIndex ? c.getSortIndex() : null,
//         }));

//         return derivedState;
//       }

//       return null;
//     } catch (err) {
//       console.error("deriveStateFromGridApi failed:", err);
//       return null;
//     }
//   };

//   const trySaveColumnState = (state) => {
//     if (!state || !Array.isArray(state) || state.length === 0) {
//       console.warn("trySaveColumnState: invalid state, skipping save", {
//         state,
//       });
//       return;
//     }

//     lastKnownColumnStateRef.current = state;

//     // Update local state immediately
//     dispatch(updateLocalPreferences({ tableId, preferences: state }));

//     // Save to backend
//     dispatch(saveTablePreferences({ tableId, preferences: state }));
//   };

//   const saveDefaultColumnsWithApi = (columnApi) => {
//     // Try to use columnApi when available
//     if (columnApi) {
//       try {
//         const state = columnApi.getColumnState();

//         if (!state || state.length === 0) {
//           console.warn(
//             "saveDefaultColumnsWithApi: Column state is empty from columnApi, using DEFAULT_DONOR_COLUMNS"
//           );
//           // Use the predefined default columns if columnApi returns empty state
//           dispatch(
//             saveTablePreferences({
//               tableId,
//               preferences: DEFAULT_DONOR_COLUMNS,
//             })
//           );
//         } else {
//           // Save current column state to backend
//           dispatch(saveTablePreferences({ tableId, preferences: state }));
//         }
//         return;
//       } catch (error) {
//         console.error("Error reading column state from columnApi:", error);
//       }
//     }

//     dispatch(
//       saveTablePreferences({ tableId, preferences: DEFAULT_DONOR_COLUMNS })
//     );
//   };

//   const saveDefaultColumns = () => {
//     if (!gridRef.current) {
//       console.error("saveDefaultColumns: gridRef.current is null");
//       return;
//     }
//     if (!gridRef.current.columnApi) {
//       console.error("saveDefaultColumns: columnApi is null");
//       return;
//     }

//     try {
//       const state = gridRef.current.columnApi.getColumnState();

//       if (!state || state.length === 0) {
//         console.warn("saveDefaultColumns: Column state is empty");
//         return;
//       }

//       // Save default columns to backend
//       dispatch(saveTablePreferences({ tableId, preferences: state }));
//     } catch (error) {
//       console.error("Error saving default columns:", error);
//     }
//   };

//   const handleColumnChange = (event) => {
//     // Set flag that user is interacting with columns
//     userIsInteractingRef.current = true;

//     // Skip if we're still initializing the grid
//     if (isInitializingRef.current) {
//       return;
//     }

//     // Clear any existing debounce timeout
//     if (debounceTimeoutRef.current) {
//       clearTimeout(debounceTimeoutRef.current);
//     }

//     // Debounce the column state save to avoid excessive API calls
//     debounceTimeoutRef.current = setTimeout(() => {
//       try {
//         let currentState = null;

//         // Try multiple methods to get column state
//         if (gridRef.current?.api) {
//           // Method 1: Try the new ag-Grid API method
//           try {
//             currentState = gridRef.current.api.getColumnState();
//           } catch (err) {
//             console.warn(
//               "handleColumnChange: gridApi.getColumnState() failed:",
//               err
//             );
//           }
//         }

//         // Method 2: Try columnApi if available
//         if (!currentState && columnApiRef.current) {
//           try {
//             currentState = columnApiRef.current.getColumnState();
//           } catch (err) {
//             console.warn(
//               "handleColumnChange: columnApi.getColumnState() failed:",
//               err
//             );
//           }
//         }

//         // Method 3: Fallback to deriving state from grid API
//         if (!currentState) {
//           currentState = deriveStateFromGridApi();
//         }

//         if (
//           !currentState ||
//           !Array.isArray(currentState) ||
//           currentState.length === 0
//         ) {
//           console.warn("handleColumnChange: Could not get valid column state");
//           return;
//         }

//         // Check if the state has actually changed
//         const lastKnownState = lastKnownColumnStateRef.current;
//         if (
//           lastKnownState &&
//           JSON.stringify(currentState) === JSON.stringify(lastKnownState)
//         ) {
//           return;
//         }

//         trySaveColumnState(currentState);

//         // Clear the user interaction flag after a delay
//         setTimeout(() => {
//           userIsInteractingRef.current = false;
//         }, 1000);
//       } catch (error) {
//         console.error(
//           "handleColumnChange: Error handling column change",
//           error
//         );
//         userIsInteractingRef.current = false;
//       }
//     }, 300); // 300ms debounce
//   };

//   useEffect(() => {
//     if (!gridReady || !gridRef.current) return;

//     const api = gridRef.current.api;
//     if (!api) return;

//     if (loading) {
//       api.showLoadingOverlay();
//       return;
//     }

//     if (!loading && filteredDonors.length === 0 && initialFetchDone) {
//       api.showNoRowsOverlay();
//       return;
//     }

//     api.hideOverlay();
//   }, [loading, filteredDonors, gridReady, initialFetchDone]);

//   const handleFilterChange = (filters) => {
//     setFilterValues(filters);
//     logger.info("Donor list filter applied", {
//       username: user?.username,
//       role: user?.role,
//       appliedFilters: filters,
//     });
//   };

//   const handleClearAll = () => {
//     clearAllFilters(gridRef.current);
//   };

//   const handleViewHistory = (donor) => {
//     if (donor.updateHistory && donor.updateHistory.length > 0) {
//       setSelectedHistory(donor.updateHistory);
//       setSelectedDonorId(donor.donorId);
//       setHistoryModalOpen(true);
//       logger.info("View donor updated history modal opened", {
//         donorId: donor.donorId,
//         username: user?.username,
//         role: user?.role,
//       });
//     } else {
//       setFeedback({
//         open: true,
//         message: "No history found for this donor.",
//         severity: "info",
//       });
//       logger.info("No donor history found", {
//         donorId: donor.donorId,
//         username: user?.username,
//         role: user?.role,
//       });
//     }
//   };

//   const handleCloseHistory = () => {
//     logger.info("View donor Updated history modal closed");
//     setHistoryModalOpen(false);
//     setSelectedHistory([]);
//     setSelectedDonorId(null);
//   };

//   const handleEdit = (data) => {
//     console.log("Edit donor clicked:", data);
//     logger.info("Edit donor clicked", {
//       donorId: data.donorId,
//       username: user?.username,
//       role: user?.role,
//     });
//     onEdit(data);
//   };

//   const handleDeleteClick = (donor) => {
//     setSelectedDonor(donor);

//     const hasDonations = donations.some(
//       (donation) => String(donation.donorId) === String(donor.donorId)
//     );

//     setSelectedDonorHasDonations(hasDonations);

//     if (hasDonations) {
//       setAlertMessageOpen(true);
//       logger.warn("Attempted to delete donor with donations", {
//         donorId: donor.donorId,
//         username: user?.username,
//         role: user?.role,
//       });
//     } else {
//       logger.info("Delete confirmation opened for donor", {
//         donorId: donor.donorId,
//         username: user?.username,
//         role: user?.role,
//       });
//       setOpenConfirm(true);
//     }
//   };

//   const handleCloseFeedback = () => {
//     setFeedback({ ...feedback, open: false });
//   };

//   const handleDeleteConfirm = () => {
//     if (selectedDonor) {
//       dispatch(deleteDonor(selectedDonor._id))
//         .unwrap()
//         .then(() => {
//           setFeedback({
//             open: true,
//             message: "Donor deleted successfully",
//             severity: "success",
//           });
//           logger.info("Donor deleted successfully", {
//             donorId: selectedDonor.donorId,
//             username: user?.username,
//             role: user?.role,
//           });
//         })
//         .catch((err) => {
//           setFeedback({
//             open: true,
//             message: "Error deleting donor",
//             severity: "error",
//           });
//           logger.error("Error deleting donor", {
//             donorId: selectedDonor.donorId,
//             username: user?.username,
//             role: user?.role,
//             error: err?.message || err,
//           });
//         });
//     }
//     setOpenConfirm(false);
//     setSelectedDonor(null);
//   };

//   const handleCloseConfirm = () => {
//     setOpenConfirm(false);
//     setSelectedDonor(null);
//   };

//   const handleRowDoubleClick = (params) => {
//     const selectedDonor = params.data;
//     logger.info("Donor row double-clicked", {
//       donorId: selectedDonor.donorId,
//       username: user?.username,
//       role: user?.role,
//     });

//     openDonorForm(selectedDonor);
//     if (gridRef.current?.api) {
//       gridRef.current.api.setFilterModel({
//         donorId: selectedDonor?.donorId,
//       });
//     }
//   };
   

//   // Donor merge handlers
//   const handleCompareClick = useCallback((donor) => {
//     setSourceDonorForMerge(donor);
//     setComparisonModalOpen(true);
//     logger.info("Compare donor clicked", {
//       donorId: donor.donorId,
//       username: user?.username,
//       role: user?.role,
//     });
//   }, [user?.username, user?.role]);

//   const handleComparisonModalClose = useCallback(() => {
//     setComparisonModalOpen(false);
//     setSourceDonorForMerge(null);
//   }, []);

//   const handleCompareConfirm = useCallback((sourceDonor, targetDonor) => {
//     setSourceDonorForMerge(sourceDonor);
//     setTargetDonorForMerge(targetDonor);
//     setComparisonModalOpen(false);
//     setCompareDialogOpen(true);
//     logger.info("Donor comparison initiated", {
//       sourceDonorId: sourceDonor.donorId,
//       targetDonorId: targetDonor.donorId,
//       username: user?.username,
//       role: user?.role,
//     });
//   }, [user?.username, user?.role]);

//   const handleCompareDialogClose = useCallback(() => {
//     setCompareDialogOpen(false);
//     setSourceDonorForMerge(null);
//     setTargetDonorForMerge(null);
//   }, []);

//   const handleMergeConfirm = async (mergePayload) => {
//     try {
//       console.log("Merging donors with payload:", mergePayload);
//       logger.info("Donor merge initiated", {
//         sourceDonorId: mergePayload.sourceDonorId,
//         targetDonorId: mergePayload.targetDonorId,
//         username: user?.username,
//         role: user?.role,
//       });

//       await dispatch(mergeDonors(mergePayload)).unwrap();
      
//       // Close comparison dialog and show result modal
//       setCompareDialogOpen(false);
//       setMergeResultModalOpen(true);
      
//       // Refresh donors list
//       dispatch(fetchDonors());
//       dispatch(fetchDonation());

//       logger.info("Donor merge completed successfully", {
//         sourceDonorId: mergePayload.sourceDonorId,
//         targetDonorId: mergePayload.targetDonorId,
//         username: user?.username,
//         role: user?.role,
//       });
//     } catch (error) {
//       logger.error("Donor merge failed", {
//         sourceDonorId: mergePayload.sourceDonorId,
//         targetDonorId: mergePayload.targetDonorId,
//         username: user?.username,
//         role: user?.role,
//         error: error?.message || error,
//       });
      
//       // Still show result modal even on error
//       setCompareDialogOpen(false);
//       setMergeResultModalOpen(true);
//     }
//   };

//   const handleMergeResultClose = useCallback(() => {
//     setMergeResultModalOpen(false);
//     setSourceDonorForMerge(null);
//     setTargetDonorForMerge(null);
//     dispatch(clearMergeResult());
//   }, [dispatch]);

//   // Effect to handle merge result
//   useEffect(() => {
//     if (mergeResult && mergeResult.success) {
//       setFeedback({
//         open: true,
//         message: `Donors merged successfully! ${mergeResult.donationsMerged || 0} donations transferred.`,
//         severity: "success",
//       });
//     }
//   }, [mergeResult]);

//   const columnDefs = useMemo(
//     () => [
//       {
//         field: "_id",
//         hide: true,
//         headerName: "ID",
//         valueGetter: (params) => params.data?._id || "-",
//         headerClass: getHeaderClass,
//       },
//       {
//         colId: "Compare",
//         headerName:"Compare",
//         width:100,
//         cellRenderer: (params) => {
//           if (!params.data) return null;
//           const donorData = params.data;
//           return (
//             (role === "superadmin" ||
//              role === "admin1" ||
//              role === "admin2") && (
//               <IconButton
//                 onClick={() => handleCompareClick(donorData)}
//                 title="Compare & Merge Donor"
//                 style={{ color: "#1976d2" }}
//                 aria-label="Compare and Merge Donor"
//                 data-log="Compare and Merge Icon Button"
//               >             
//                <DifferenceIcon />
//               </IconButton>
//             )
//           );
//         },
//       },
//       {
//         colId: "Actions",
//         headerName: "Actions",
//         cellRenderer: (params) => {
//           if (!params.data) return null;
//           const donorData = params.data;
//           const hasDonations = donations.some(
//             (donation) => String(donation.donorId) === String(donorData.donorId)
//           );
//           return (
//             <div style={{ display: "flex", gap: "10px" }}>
//               {(role === "admin1" ||
//                 role === "admin2" ||
//                 role === "superadmin" ||
//                 role === "editor1" ||
//                 role === "editor2") && (
//                 <IconButton
//                   onClick={() => handleEdit(donorData)}
//                   title="Edit"
//                   style={{ color: "#1976d2" }}
//                   aria-label="Edit Donor"
//                   data-log="Edit Icon Button"
//                 >
//                   <EditIcon />
//                 </IconButton>
//               )}

//               {(role === "superadmin" ||
//                 role === "admin1" ||
//                 role === "admin2") && (
//                 <IconButton
//                   onClick={() => handleDeleteClick(donorData)}
//                   title={
//                     hasDonations ? "Delete donor (has donations)" : "Delete"
//                   }
//                   style={{
//                     color: hasDonations ? "gray" : "#d32f2f",
//                     cursor: "pointer",
//                   }}
//                   data-log="Delete Icon Button"
//                 >
//                   <DeleteIcon />
//                 </IconButton>
//               )}
//               {(role === "admin1" ||
//                 role === "superadmin" ||
//                 role === "admin2") && (
//                 <IconButton
//                   onClick={() => handleViewHistory(donorData)}
//                   title="View Update History"
//                   style={{ color: "#1976D2" }}
//                   aria-label="View Update History"
//                   data-log="View History Icon Button"
//                 >
//                   <HistoryIcon />
//                 </IconButton>
//               )}
//             </div>
//           );
//         },
//       },
//       {
//         field: "id",
//         headerName: "S.No",
//         valueGetter: (params) => params.node.rowIndex + 1,
//         width: 90,
//         headerClass: getHeaderClass,
//       },
//       {
//         field: "donorId",
//         headerName: "Donor ID",
//         filter: "agTextColumnFilter",
//         valueGetter: (params) => params.data?.donorId || "-",
//         width: 100,
//         headerClass: getHeaderClass,
//       },
//       {
//         field: "salutation",
//         headerName: "Salutation",
//         filter: "agTextColumnFilter",
//         valueGetter: (params) => params.data?.salutation || "-",
//         width: 90,
//         headerClass: getHeaderClass,
//       },
//       {
//         field: "initial",
//         headerName: "Initial",
//         filter: "agTextColumnFilter",
//         valueGetter: (params) => params.data?.initial || "-",
//         width: 90,
//         headerClass: getHeaderClass,
//       },
//       {
//         field: "firstName",
//         headerName: "First Name",
//         filter: "agTextColumnFilter",
//         valueGetter: (params) => params.data?.firstName || "-",
//         width: 150,
//         headerClass: getHeaderClass,
//       },
//       {
//         field: "lastName",
//         headerName: "Last Name",
//         filter: "agTextColumnFilter",
//         valueGetter: (params) => params.data?.lastName || "-",
//         width: 150,
//         headerClass: getHeaderClass,
//       },
//       {
//         field: "address",
//         headerName: "Address",
//         filter: "agTextColumnFilter",
//         valueGetter: (params) => params.data?.address || "-",
//         width: 110,
//         headerClass: getHeaderClass,
//       },
//       {
//         field: "address1",
//         headerName: "Address1",
//         filter: "agTextColumnFilter",
//         valueGetter: (params) => params.data?.address1 || "-",
//         width: 110,
//         headerClass: getHeaderClass,
//       },
//       {
//         field: "address2",
//         headerName: "Address2",
//         filter: "agTextColumnFilter",
//         valueGetter: (params) => params.data?.address2 || "-",
//         width: 110,
//         headerClass: getHeaderClass,
//       },
//     {
//       field: "city",
//       headerName: "City",
//       filter: "agTextColumnFilter",
//       valueGetter: (params) => params.data?.city || "-",
//       width: 110,
//       headerClass: getHeaderClass,
//     },
//     {
//       field: "state",
//       headerName: "State",
//       filter: "agTextColumnFilter",
//       valueGetter: (params) => params.data?.state || "-",
//       width: 110,
//       headerClass: getHeaderClass,
//     },
//     {
//       field: "country",
//       headerName: "Country",
//       filter: "agTextColumnFilter",
//       valueGetter: (params) => params.data?.country || "-",
//       width: 110,
//       headerClass: getHeaderClass,
//     },
//     {
//       field: "pincode",
//       headerName: "Pincode",
//       filter: "agTextColumnFilter",
//       valueGetter: (params) => params.data?.pincode || "-",
//       width: 100,
//       headerClass: getHeaderClass,
//     },
//     {
//       field: "panCardNo",
//       headerName: "PAN No",
//       filter: "agTextColumnFilter",
//       valueGetter: (params) => params.data?.panCardNo || "-",
//       width: 180,
//       headerClass: getHeaderClass,
//     },
//     {
//       field: "mobile1",
//       headerName: "Mobile1",
//       filter: "agTextColumnFilter",
//       valueGetter: (params) => params.data?.mobile1 || "-",
//       width: 120,
//       headerClass: getHeaderClass,
//       filterParams: {
//         maxNumConditions: 1,
//         trimInput: true,

//         textMatcher: ({ filterText, value, filterOption }) => {
//           const rawValue = value ?? "";
//           const valueDigits = rawValue.replace(/\D/g, "");

//           // BLANK / NOT BLANK
//           if (filterOption === "blank") {
//             return valueDigits.length === 0;
//           }
//           if (filterOption === "notBlank") {
//             return valueDigits.length > 0;
//           }

//           // If no filter text, allow row
//           if (!filterText) return true;

//           const filterDigits = filterText.replace(/\D/g, "");
//           if (filterDigits.length < 3) return true;

//           switch (filterOption) {
//             case "contains":
//               return valueDigits.includes(filterDigits);

//             case "notContains":
//               return !valueDigits.includes(filterDigits);

//             case "equals":
//               return valueDigits === filterDigits;

//             case "notEqual":
//               return valueDigits !== filterDigits;

//             case "startsWith":
//               return valueDigits.startsWith(filterDigits);

//             case "endsWith":
//               return valueDigits.endsWith(filterDigits);

//             default:
//               return true;
//           }
//         },
//       },
//     },
//     {
//       field: "mobile2",
//       headerName: "Mobile2",
//       filter: "agTextColumnFilter",
//       valueGetter: (params) => params.data?.mobile2 || "-",
//       width: 120,
//       headerClass: getHeaderClass,
//       filterParams: {
//         maxNumConditions: 1,
//         trimInput: true,

//         textMatcher: ({ filterText, value, filterOption }) => {
//           const rawValue = value ?? "";
//           const valueDigits = rawValue.replace(/\D/g, "");

//           // BLANK / NOT BLANK
//           if (filterOption === "blank") {
//             return valueDigits.length === 0;
//           }
//           if (filterOption === "notBlank") {
//             return valueDigits.length > 0;
//           }

//           // If no filter text, allow row
//           if (!filterText) return true;

//           const filterDigits = filterText.replace(/\D/g, "");
//           if (filterDigits.length < 3) return true;

//           switch (filterOption) {
//             case "contains":
//               return valueDigits.includes(filterDigits);

//             case "notContains":
//               return !valueDigits.includes(filterDigits);

//             case "equals":
//               return valueDigits === filterDigits;

//             case "notEqual":
//               return valueDigits !== filterDigits;

//             case "startsWith":
//               return valueDigits.startsWith(filterDigits);

//             case "endsWith":
//               return valueDigits.endsWith(filterDigits);

//             default:
//               return true;
//           }
//         },
//       },
//     },  
//       {
//         field: "mailId",
//         headerName: "MailId",
//         filter: "agTextColumnFilter",
//         valueGetter: (params) => params.data?.mailId || "-",
//         width: 150,
//         headerClass: getHeaderClass,
//       },
//       {
//         field: "status",
//         headerName: "Status",
//         filter: "agTextColumnFilter",
//         valueGetter: (params) => params.data?.status || "-",
//         width: 100,
//         headerClass: getHeaderClass,
//       },
//       {
//         field: "prasad",
//         headerName: "Prasad",
//         filter: "agTextColumnFilter",
//         valueGetter: (params) =>
//           params.data?.prasad === undefined || params.data?.prasad === null
//             ? "-"
//             : params.data.prasad
//             ? "Yes"
//             : "No",
//         width: 80,
//         headerClass: getHeaderClass,
//       },
//       {
//         field: "donorRemarks",
//         headerName: "Donor Remarks",
//         filter: "agTextColumnFilter",
//         valueGetter: (params) => params.data?.donorRemarks || "-",
//         width: 150,
//         headerClass: getHeaderClass,
//       },
//     ],
//     [donations, role]
//   );

//   const onFirstDataRendered = () => {
//     setIsFirstLoad(false);
//     if (gridRef.current && donors && donors.length > 0) {
//       gridRef.current.api.hideOverlay();
//     }
//   };

//   const exportToExcel = () => {
//     if (!gridRef.current) {
//       return;
//     }
//     gridRef.current.exportDataAsCsv({
//       fileName: `Donors_export ${getSystemFormattedTimestamp()}.csv`,
//     });
//   };

//   return (
//     <div
//       style={{
//         width: "100%",
//         display: "flex",
//         flexDirection: "column",
//         height: "calc(100vh - 200px)",
//       }}
//     >
//       <Filter
//         onFilterChange={handleFilterChange}
//         fields={["donorId", "name", "mobile", "pincode", "status", "remarks"]}
//       />
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "end",
//           marginBottom: "10px",
//         }}
//       >
//         <Button
//           variant="contained"
//           color="error"
//           onClick={handleClearAll}
//           sx={{ mr: 2 }}
//         >
//           Clear All Filters
//         </Button>
//         {role === "superadmin" || role === "admin1" || role === "admin2" ? (
//           <Button onClick={exportToExcel} variant="contained" color="primary">
//             <DriveFileMoveIcon /> Export
//           </Button>
//         ) : null}
//       </div>

//       <HistoryModal
//         title="Donor Updated History"
//         open={historyModalOpen}
//         onClose={handleCloseHistory}
//         history={selectedHistory}
//       />

//       <ComparisonSelectedModal
//         open={comparisonModalOpen}
//         onClose={handleComparisonModalClose}
//         selectedDonor={sourceDonorForMerge}
//         donors={donors}
//         onCompare={handleCompareConfirm}
//       />

//       <CompareDonorsDialog
//         open={compareDialogOpen}
//         onClose={handleCompareDialogClose}
//         sourceDonor={sourceDonorForMerge}
//         targetDonor={targetDonorForMerge}
//         onMerge={handleMergeConfirm}
//         loading={mergeLoading}
//       />

//       <ManualMergeDialog
//         open={mergeResultModalOpen}
//         onClose={handleMergeResultClose}
//         mergeResult={mergeResult}
//       />

//       <div className="ag-theme-alpine" style={{ height: "100%", width: "100%", overflow: "auto" }}>
//         <AgGridReact
//           key="donor-grid"
//           ref={gridRef}
//           rowData={filteredDonors}
//           columnDefs={columnDefs}
//           domLayout="autoHeight"
//           onGridReady={onGridReady}
//           onFirstDataRendered={onFirstDataRendered}
//           pagination
//           paginationPageSize={10}
//           paginationPageSizeSelector={[10, 20, 50]}
//           loadingOverlayComponent={AgGridLoader}
//           loadingOverlayComponentParams={{
//             loadingMessage: "Loading donors, please wait...",
//           }}
//           onRowDoubleClicked={handleRowDoubleClick}
//           onFilterChanged={(params) => params.api.refreshHeader()}
//           onColumnMoved={(event) => {
//             handleColumnChange(event);
//           }}
//           onColumnPinned={(event) => {
//             handleColumnChange(event);
//           }}
//           onColumnVisible={(event) => {
//             handleColumnChange(event);
//           }}
//           onColumnResized={(event) => {
//             handleColumnChange(event);
//           }}
//           onDragStopped={(event) => {
//             handleColumnChange(event);
//           }}
//           onColumnRowGroupChanged={(event) => {
//             handleColumnChange(event);
//           }}
//           suppressColumnMoveAnimation={false}
//           animateRows={true}
//         />
//       </div>

//       <AlertMessage
//         title="Donor Delete Alert"
//         open={alertMessageOpen}
//         setOpen={setAlertMessageOpen}
//         message="This donor has donations. You cannot delete this donor."
//       />

//       <ConfirmationDialog
//         open={openConfirm}
//         title="Delete Donor"
//         message="Are you sure you want to delete this donor?"
//         onConfirm={handleDeleteConfirm}
//         onCancel={handleCloseConfirm}
//       />

//       <SnackBarAlert feedback={feedback} onClose={handleCloseFeedback} />
//     </div>
//   );
// };

// export default DonorList;


import { useEffect, useRef, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchDonors, deleteDonor } from "../../redux/donorSlice";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { IconButton, Button } from "@mui/material";
import { filterDonors } from "./utils/DonorUtils";
import { getHeaderClass } from "../../utils/agGridHelpers";
import DriveFileMoveIcon from "@mui/icons-material/DriveFileMove";
import DifferenceIcon from "@mui/icons-material/Difference";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import HistoryIcon from "@mui/icons-material/History";
import Filter from "../Filter";
import AgGridLoader from "../AgGridLoader";
import ConfirmationDialog from "../ConfirmationDialog";
import AlertMessage from "../AlertMessage";
import { fetchDonation } from "../../redux/donationSlice";
import { getSystemFormattedTimestamp } from "../../utils/dateFormatted";
import { clearAllFilters } from "../../utils/agGridHelpers";
import { logger } from "../../utils/logger";
import SnackBarAlert from "../SnackBarAlert";
import HistoryModal from "../HistoryModal";
import ComparisonSelectedModal from "../DonorMerge/ComparisonSelectedModal"; // ✅ phase3
import CompareDonorsDialog from "../DonorMerge/CompareDonorsDialog";         // ✅ phase3
import ManualMergeDialog from "../DonorMerge/ManualMergeDialog";             // ✅ phase3
import { mergeDonors, clearMergeResult } from "../../redux/donorMergeSlice"; // ✅ phase3
import {
  updateLocalPreferences,
  saveTablePreferences,
  loadTablePreferences,
} from "../../redux/tablePreferenceSlice";                                   // ✅ phase3
import { DEFAULT_DONOR_COLUMNS } from "../../config/donorTableColumns";      // ✅ phase3

const DonorList = ({ onEdit, openDonorForm }) => {
  const dispatch = useDispatch();
  const { donors, loading } = useSelector((state) => state.donor || {});
  const { role } = useSelector((state) => state.auth || "user");
  const { user } = useSelector((state) => state.auth);

  // ✅ fixes branch: donationsStatus for donationsReady check
  const {
    donations,
    status: donationsStatus,
  } = useSelector((state) => state.donation || {});
  const donationsReady = donationsStatus === "succeeded";

  // ✅ phase3: merge state
  const { loading: mergeLoading, mergeResult } = useSelector(
    (state) => state.donorMerge || {}
  );

  const [selectedDonor, setSelectedDonor] = useState(null);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedDonorHasDonations, setSelectedDonorHasDonations] =
    useState(false);
  const [alertMessageOpen, setAlertMessageOpen] = useState(false);
  const [gridReady, setGridReady] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  // ✅ phase3: multiple refs for column state management
  const gridRef = useRef(null);
  const gridApiRef = useRef(null);
  const columnApiRef = useRef(null);
  const lastKnownColumnStateRef = useRef(null);
  const isInitializingRef = useRef(false);
  const debounceTimeoutRef = useRef(null);
  const userIsInteractingRef = useRef(false);

  const [initialFetchDone, setInitialFetchDone] = useState(false);
  const [feedback, setFeedback] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [historyModalOpen, setHistoryModalOpen] = useState(false);
  const [selectedHistory, setSelectedHistory] = useState([]);
  const [selectedDonorId, setSelectedDonorId] = useState(null);
  const [filterValues, setFilterValues] = useState({});
  const [hasAppliedInitialState, setHasAppliedInitialState] = useState(false);

  // ✅ phase3: donor merge states
  const [comparisonModalOpen, setComparisonModalOpen] = useState(false);
  const [compareDialogOpen, setCompareDialogOpen] = useState(false);
  const [mergeResultModalOpen, setMergeResultModalOpen] = useState(false);
  const [sourceDonorForMerge, setSourceDonorForMerge] = useState(null);
  const [targetDonorForMerge, setTargetDonorForMerge] = useState(null);

  const filteredDonors = useMemo(
    () => filterDonors(donors, filterValues),
    [donors, filterValues]
  );

  // ✅ phase3: cleanup debounce on unmount
  useEffect(() => {
    return () => {
      if (debounceTimeoutRef.current) {
        clearTimeout(debounceTimeoutRef.current);
      }
    };
  }, []);

  // ✅ phase3: column preference table ID
  const tableId = "donorTable";
  const tableState = useSelector(
    (state) => state.tablePreference?.tables?.[tableId]
  );

  // ✅ phase3: load column preferences from backend on mount
  useEffect(() => {
    dispatch(
      loadTablePreferences({ tableId, defaultColumns: DEFAULT_DONOR_COLUMNS })
    );
  }, [dispatch, tableId]);

  // ✅ phase3: apply saved column state once grid + preferences are ready
  useEffect(() => {
    if (!gridReady || !gridRef.current?.api || hasAppliedInitialState) return;
    if (tableState?.loading) return;

    isInitializingRef.current = true;

    try {
      const savedState = tableState?.columns;

      if (savedState && Array.isArray(savedState) && savedState.length > 0) {
        gridRef.current.api.applyColumnState({
          state: savedState,
          applyOrder: true,
        });
        lastKnownColumnStateRef.current = [...savedState];
      } else {
        gridRef.current.api.applyColumnState({
          state: DEFAULT_DONOR_COLUMNS,
          applyOrder: true,
        });
        lastKnownColumnStateRef.current = [...DEFAULT_DONOR_COLUMNS];
        setTimeout(
          () => saveDefaultColumnsWithApi(columnApiRef.current),
          500
        );
      }

      setHasAppliedInitialState(true);
    } catch (error) {
      console.error("Error applying column state:", error);
    }

    setTimeout(() => {
      isInitializingRef.current = false;
    }, 500);
  }, [
    gridReady,
    tableState?.columns,
    tableState?.loading,
    hasAppliedInitialState,
  ]);

  // Fetch donors and donations only if store is empty
  useEffect(() => {
    if (!gridReady) return;

    const fetchAll = async () => {
      if (!donors || donors.length === 0) {
        dispatch(fetchDonors());
        setInitialFetchDone(true);
        if (!donations || donations.length === 0) {
          dispatch(fetchDonation());
        }
      }
    };

    fetchAll();
  }, [dispatch, gridReady]);

  const onGridReady = (params) => {
    if (!params || !params.api) {
      console.error("Grid params or api is undefined");
      setGridReady(true);
      return;
    }

    isInitializingRef.current = true;

    gridRef.current = params;
    gridApiRef.current = params.api;
    columnApiRef.current = params.columnApi || params.api;
    setGridReady(true);

    setTimeout(() => {
      isInitializingRef.current = false;
    }, 1000);
  };

  // ✅ phase3: overlay management using api methods
  useEffect(() => {
    if (!gridReady || !gridRef.current) return;

    const api = gridRef.current.api;
    if (!api) return;

    if (loading) {
      api.showLoadingOverlay();
      return;
    }

    if (!loading && filteredDonors.length === 0 && initialFetchDone) {
      api.showNoRowsOverlay();
      return;
    }

    api.hideOverlay();
  }, [loading, filteredDonors, gridReady, initialFetchDone]);

  // ✅ phase3: column state helpers
  const deriveStateFromGridApi = () => {
    try {
      if (!gridApiRef.current) {
        console.warn("deriveStateFromGridApi: gridApiRef.current is null");
        return null;
      }

      if (gridApiRef.current.getColumnState) {
        try {
          return gridApiRef.current.getColumnState();
        } catch (err) {
          console.warn("deriveStateFromGridApi: getColumnState failed:", err);
        }
      }

      if (gridApiRef.current.getAllColumns) {
        const cols = gridApiRef.current.getAllColumns();
        if (!cols) return null;

        return cols.map((c) => ({
          colId: c.getColId(),
          hide: !c.isVisible(),
          width: c.getActualWidth(),
          pinned: c.getPinned ? c.getPinned() : null,
          sort: c.getSort ? c.getSort() : null,
          sortIndex: c.getSortIndex ? c.getSortIndex() : null,
        }));
      }

      return null;
    } catch (err) {
      console.error("deriveStateFromGridApi failed:", err);
      return null;
    }
  };

  const trySaveColumnState = (state) => {
    if (!state || !Array.isArray(state) || state.length === 0) {
      console.warn("trySaveColumnState: invalid state, skipping save");
      return;
    }

    lastKnownColumnStateRef.current = state;
    dispatch(updateLocalPreferences({ tableId, preferences: state }));
    dispatch(saveTablePreferences({ tableId, preferences: state }));
  };

  const saveDefaultColumnsWithApi = (columnApi) => {
    if (columnApi) {
      try {
        const state = columnApi.getColumnState();
        if (!state || state.length === 0) {
          dispatch(
            saveTablePreferences({ tableId, preferences: DEFAULT_DONOR_COLUMNS })
          );
        } else {
          dispatch(saveTablePreferences({ tableId, preferences: state }));
        }
        return;
      } catch (error) {
        console.error("Error reading column state from columnApi:", error);
      }
    }

    dispatch(
      saveTablePreferences({ tableId, preferences: DEFAULT_DONOR_COLUMNS })
    );
  };

  const handleColumnChange = (event) => {
    userIsInteractingRef.current = true;

    if (isInitializingRef.current) return;

    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }

    debounceTimeoutRef.current = setTimeout(() => {
      try {
        let currentState = null;

        if (gridRef.current?.api) {
          try {
            currentState = gridRef.current.api.getColumnState();
          } catch (err) {
            console.warn("handleColumnChange: getColumnState() failed:", err);
          }
        }

        if (!currentState && columnApiRef.current) {
          try {
            currentState = columnApiRef.current.getColumnState();
          } catch (err) {
            console.warn(
              "handleColumnChange: columnApi.getColumnState() failed:",
              err
            );
          }
        }

        if (!currentState) {
          currentState = deriveStateFromGridApi();
        }

        if (!currentState || !Array.isArray(currentState) || currentState.length === 0) {
          console.warn("handleColumnChange: Could not get valid column state");
          return;
        }

        const lastKnownState = lastKnownColumnStateRef.current;
        if (
          lastKnownState &&
          JSON.stringify(currentState) === JSON.stringify(lastKnownState)
        ) {
          return;
        }

        trySaveColumnState(currentState);

        setTimeout(() => {
          userIsInteractingRef.current = false;
        }, 1000);
      } catch (error) {
        console.error("handleColumnChange: Error handling column change", error);
        userIsInteractingRef.current = false;
      }
    }, 300);
  };

  // ✅ fixes branch: page: "Donors" added to logger
  const handleFilterChange = (filters) => {
    setFilterValues(filters);
    logger.info("Donor list filter applied", {
      page: "Donors",
      username: user?.username,
      role: user?.role,
      appliedFilters: filters,
    });
  };

  const handleClearAll = () => {
    clearAllFilters(gridRef.current);
  };

  // ✅ fixes branch: page: "Donors" added to logger
  const handleViewHistory = (donor) => {
    if (donor.updateHistory && donor.updateHistory.length > 0) {
      setSelectedHistory(donor.updateHistory);
      setSelectedDonorId(donor.donorId);
      setHistoryModalOpen(true);
      logger.info("View donor updated history modal opened", {
        page: "Donors",
        donorId: donor.donorId,
        username: user?.username,
        role: user?.role,
      });
    } else {
      setFeedback({
        open: true,
        message: "No history found for this donor.",
        severity: "info",
      });
      logger.info("No donor history found", {
        page: "Donors",
        donorId: donor.donorId,
        username: user?.username,
        role: user?.role,
      });
    }
  };

  const handleCloseHistory = () => {
    logger.info("View donor Updated history modal closed", {
      page: "Donors",
      username: user?.username,
      role: user?.role,
    });
    setHistoryModalOpen(false);
    setSelectedHistory([]);
    setSelectedDonorId(null);
  };

  // ✅ fixes branch: page: "Donors" added to logger
  const handleEdit = (data) => {
    logger.info("Edit donor clicked", {
      page: "Donors",
      donorId: data.donorId,
      username: user?.username,
      role: user?.role,
    });
    onEdit(data);
  };

  // ✅ fixes branch: donationsReady guard + page: "Donors" in logger
  const handleDeleteClick = (donor) => {
    if (!donationsReady) return; // ✅ guard: donations not yet loaded

    setSelectedDonor(donor);

    const hasDonations = donations.some(
      (donation) => String(donation.donorId) === String(donor.donorId)
    );

    setSelectedDonorHasDonations(hasDonations);

    if (hasDonations) {
      setAlertMessageOpen(true);
      logger.warn("Attempted to delete donor with donations", {
        page: "Donors",
        donorId: donor.donorId,
        username: user?.username,
        role: user?.role,
      });
    } else {
      logger.info("Delete confirmation opened for donor", {
        page: "Donors",
        donorId: donor.donorId,
        username: user?.username,
        role: user?.role,
      });
      setOpenConfirm(true);
    }
  };

  const handleCloseFeedback = () => {
    setFeedback({ ...feedback, open: false });
  };

  // ✅ fixes branch: page: "Donors" in logger
  const handleDeleteConfirm = () => {
    if (selectedDonor) {
      dispatch(deleteDonor(selectedDonor._id))
        .unwrap()
        .then(() => {
          setFeedback({
            open: true,
            message: "Donor deleted successfully",
            severity: "success",
          });
          logger.info("Donor deleted successfully", {
            page: "Donors",
            donorId: selectedDonor.donorId,
            username: user?.username,
            role: user?.role,
          });
        })
        .catch((err) => {
          setFeedback({
            open: true,
            message: "Error deleting donor",
            severity: "error",
          });
          logger.error("Error deleting donor", {
            page: "Donors",
            donorId: selectedDonor.donorId,
            username: user?.username,
            role: user?.role,
            error: err?.message || err,
          });
        });
    }
    setOpenConfirm(false);
    setSelectedDonor(null);
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
    setSelectedDonor(null);
  };

  // ✅ fixes branch: page: "Donors" in logger
  const handleRowDoubleClick = (params) => {
    const selectedDonor = params.data;
    logger.info("Donor row double-clicked", {
      page: "Donors",
      donorId: selectedDonor.donorId,
      username: user?.username,
      role: user?.role,
    });

    openDonorForm(selectedDonor);
    if (gridRef.current?.api) {
      gridRef.current.api.setFilterModel({
        donorId: selectedDonor?.donorId,
      });
    }
  };

  // ✅ phase3: donor merge handlers
  const handleCompareClick = useCallback(
    (donor) => {
      setSourceDonorForMerge(donor);
      setComparisonModalOpen(true);
      logger.info("Compare donor clicked", {
        page: "Donors",
        donorId: donor.donorId,
        username: user?.username,
        role: user?.role,
      });
    },
    [user?.username, user?.role]
  );

  const handleComparisonModalClose = useCallback(() => {
    setComparisonModalOpen(false);
    setSourceDonorForMerge(null);
  }, []);

  const handleCompareConfirm = useCallback(
    (sourceDonor, targetDonor) => {
      setSourceDonorForMerge(sourceDonor);
      setTargetDonorForMerge(targetDonor);
      setComparisonModalOpen(false);
      setCompareDialogOpen(true);
      logger.info("Donor comparison initiated", {
        page: "Donors",
        sourceDonorId: sourceDonor.donorId,
        targetDonorId: targetDonor.donorId,
        username: user?.username,
        role: user?.role,
      });
    },
    [user?.username, user?.role]
  );

  const handleCompareDialogClose = useCallback(() => {
    setCompareDialogOpen(false);
    setSourceDonorForMerge(null);
    setTargetDonorForMerge(null);
  }, []);

  const handleMergeConfirm = async (mergePayload) => {
    try {
      logger.info("Donor merge initiated", {
        page: "Donors",
        sourceDonorId: mergePayload.sourceDonorId,
        targetDonorId: mergePayload.targetDonorId,
        username: user?.username,
        role: user?.role,
      });

      await dispatch(mergeDonors(mergePayload)).unwrap();

      setCompareDialogOpen(false);
      setMergeResultModalOpen(true);

      dispatch(fetchDonors());
      dispatch(fetchDonation());

      logger.info("Donor merge completed successfully", {
        page: "Donors",
        sourceDonorId: mergePayload.sourceDonorId,
        targetDonorId: mergePayload.targetDonorId,
        username: user?.username,
        role: user?.role,
      });
    } catch (error) {
      logger.error("Donor merge failed", {
        page: "Donors",
        sourceDonorId: mergePayload.sourceDonorId,
        targetDonorId: mergePayload.targetDonorId,
        username: user?.username,
        role: user?.role,
        error: error?.message || error,
      });

      setCompareDialogOpen(false);
      setMergeResultModalOpen(true);
    }
  };

  const handleMergeResultClose = useCallback(() => {
    setMergeResultModalOpen(false);
    setSourceDonorForMerge(null);
    setTargetDonorForMerge(null);
    dispatch(clearMergeResult());
  }, [dispatch]);

  useEffect(() => {
    if (mergeResult && mergeResult.success) {
      setFeedback({
        open: true,
        message: `Donors merged successfully! ${
          mergeResult.donationsMerged || 0
        } donations transferred.`,
        severity: "success",
      });
    }
  }, [mergeResult]);

  // ✅ phase3 + fixes: donationsReady added to deps for proper disable state
  const columnDefs = useMemo(
    () => [
      {
        field: "_id",
        hide: true,
        headerName: "ID",
        valueGetter: (params) => params.data?._id || "-",
        headerClass: getHeaderClass,
      },
      {
        colId: "Compare",
        headerName: "Compare",
        width: 100,
        cellRenderer: (params) => {
          if (!params.data) return null;
          const donorData = params.data;
          return (
            (role === "superadmin" ||
              role === "admin1" ||
              role === "admin2") && (
              <IconButton
                onClick={() => handleCompareClick(donorData)}
                title="Compare & Merge Donor"
                style={{ color: "#1976d2" }}
                aria-label="Compare and Merge Donor"
                data-log="Compare and Merge Icon Button"
              >
                <DifferenceIcon />
              </IconButton>
            )
          );
        },
      },
      {
        colId: "Actions",
        headerName: "Actions",
        cellRenderer: (params) => {
          if (!params.data) return null;
          const donorData = params.data;
          const hasDonations = donations.some(
            (donation) =>
              String(donation.donorId) === String(donorData.donorId)
          );

          return (
            <div style={{ display: "flex", gap: "10px" }}>
              {(role === "admin1" ||
                role === "admin2" ||
                role === "superadmin" ||
                role === "editor1" ||
                role === "editor2") && (
                <IconButton
                  onClick={() => handleEdit(donorData)}
                  title="Edit"
                  style={{ color: "#1976d2" }}
                  aria-label="Edit Donor"
                  data-log="Edit Icon Button"
                >
                  <EditIcon />
                </IconButton>
              )}

              {(role === "superadmin" ||
                role === "admin1" ||
                role === "admin2") && (
                <IconButton
                  onClick={() => handleDeleteClick(donorData)}
                  // ✅ fixes branch: disable when donations not loaded
                  disabled={!donationsReady}
                  title={
                    !donationsReady
                      ? "Loading donations, please wait..."
                      : hasDonations
                      ? "Cannot delete: donor has donations"
                      : "Delete donor"
                  }
                  style={{
                    color:
                      !donationsReady || hasDonations ? "gray" : "#d32f2f",
                    cursor: !donationsReady ? "not-allowed" : "pointer",
                  }}
                  data-log="Delete Icon Button"
                >
                  <DeleteIcon />
                </IconButton>
              )}

              {(role === "admin1" ||
                role === "superadmin" ||
                role === "admin2") && (
                <IconButton
                  onClick={() => handleViewHistory(donorData)}
                  title="View Update History"
                  style={{ color: "#1976D2" }}
                  aria-label="View Update History"
                  data-log="View History Icon Button"
                >
                  <HistoryIcon />
                </IconButton>
              )}
            </div>
          );
        },
      },
      {
        field: "id",
        headerName: "S.No",
        valueGetter: (params) => params.node.rowIndex + 1,
        width: 90,
        headerClass: getHeaderClass,
      },
      {
        field: "donorId",
        headerName: "Donor ID",
        filter: "agTextColumnFilter",
        // ✅ fixes branch: filterParams for donorId
        filterParams: {
          applyButton: true,
          resetButton: true,
          closeOnApply: true,
        },
        valueGetter: (params) => params.data?.donorId || "-",
        width: 100,
        headerClass: getHeaderClass,
      },
      {
        field: "salutation",
        headerName: "Salutation",
        filter: "agTextColumnFilter",
        valueGetter: (params) => params.data?.salutation || "-",
        width: 90,
        headerClass: getHeaderClass,
      },
      {
        field: "initial",
        headerName: "Initial",
        filter: "agTextColumnFilter",
        valueGetter: (params) => params.data?.initial || "-",
        width: 90,
        headerClass: getHeaderClass,
      },
      {
        field: "firstName",
        headerName: "First Name",
        filter: "agTextColumnFilter",
        valueGetter: (params) => params.data?.firstName || "-",
        width: 150,
        headerClass: getHeaderClass,
      },
      {
        field: "lastName",
        headerName: "Last Name",
        filter: "agTextColumnFilter",
        valueGetter: (params) => params.data?.lastName || "-",
        width: 150,
        headerClass: getHeaderClass,
      },
      {
        field: "address",
        headerName: "Address",
        filter: "agTextColumnFilter",
        valueGetter: (params) => params.data?.address || "-",
        width: 110,
        headerClass: getHeaderClass,
      },
      {
        field: "address1",
        headerName: "Address1",
        filter: "agTextColumnFilter",
        valueGetter: (params) => params.data?.address1 || "-",
        width: 110,
        headerClass: getHeaderClass,
      },
      {
        field: "address2",
        headerName: "Address2",
        filter: "agTextColumnFilter",
        valueGetter: (params) => params.data?.address2 || "-",
        width: 110,
        headerClass: getHeaderClass,
      },
      {
        field: "city",
        headerName: "City",
        filter: "agTextColumnFilter",
        valueGetter: (params) => params.data?.city || "-",
        width: 110,
        headerClass: getHeaderClass,
      },
      {
        field: "state",
        headerName: "State",
        filter: "agTextColumnFilter",
        valueGetter: (params) => params.data?.state || "-",
        width: 110,
        headerClass: getHeaderClass,
      },
      {
        field: "country",
        headerName: "Country",
        filter: "agTextColumnFilter",
        valueGetter: (params) => params.data?.country || "-",
        width: 110,
        headerClass: getHeaderClass,
      },
      {
        field: "pincode",
        headerName: "Pincode",
        filter: "agTextColumnFilter",
        valueGetter: (params) => params.data?.pincode || "-",
        width: 100,
        headerClass: getHeaderClass,
      },
      {
        field: "panCardNo",
        headerName: "PAN No",
        filter: "agTextColumnFilter",
        valueGetter: (params) => params.data?.panCardNo || "-",
        width: 180,
        headerClass: getHeaderClass,
      },
      {
        field: "mobile1",
        headerName: "Mobile1",
        filter: "agTextColumnFilter",
        valueGetter: (params) => params.data?.mobile1 || "-",
        width: 120,
        headerClass: getHeaderClass,
        filterParams: {
          maxNumConditions: 1,
          trimInput: true,
          textMatcher: ({ filterText, value, filterOption }) => {
            const rawValue = value ?? "";
            const valueDigits = rawValue.replace(/\D/g, "");

            if (filterOption === "blank") return valueDigits.length === 0;
            if (filterOption === "notBlank") return valueDigits.length > 0;
            if (!filterText) return true;

            const filterDigits = filterText.replace(/\D/g, "");
            if (filterDigits.length < 3) return true;

            switch (filterOption) {
              case "contains":     return valueDigits.includes(filterDigits);
              case "notContains":  return !valueDigits.includes(filterDigits);
              case "equals":       return valueDigits === filterDigits;
              case "notEqual":     return valueDigits !== filterDigits;
              case "startsWith":   return valueDigits.startsWith(filterDigits);
              case "endsWith":     return valueDigits.endsWith(filterDigits);
              default:             return true;
            }
          },
        },
      },
      {
        field: "mobile2",
        headerName: "Mobile2",
        filter: "agTextColumnFilter",
        valueGetter: (params) => params.data?.mobile2 || "-",
        width: 120,
        headerClass: getHeaderClass,
        filterParams: {
          maxNumConditions: 1,
          trimInput: true,
          textMatcher: ({ filterText, value, filterOption }) => {
            const rawValue = value ?? "";
            const valueDigits = rawValue.replace(/\D/g, "");

            if (filterOption === "blank") return valueDigits.length === 0;
            if (filterOption === "notBlank") return valueDigits.length > 0;
            if (!filterText) return true;

            const filterDigits = filterText.replace(/\D/g, "");
            if (filterDigits.length < 3) return true;

            switch (filterOption) {
              case "contains":     return valueDigits.includes(filterDigits);
              case "notContains":  return !valueDigits.includes(filterDigits);
              case "equals":       return valueDigits === filterDigits;
              case "notEqual":     return valueDigits !== filterDigits;
              case "startsWith":   return valueDigits.startsWith(filterDigits);
              case "endsWith":     return valueDigits.endsWith(filterDigits);
              default:             return true;
            }
          },
        },
      },
      {
        field: "mailId",
        headerName: "MailId",
        filter: "agTextColumnFilter",
        valueGetter: (params) => params.data?.mailId || "-",
        width: 150,
        headerClass: getHeaderClass,
      },
      {
        field: "status",
        headerName: "Status",
        filter: "agTextColumnFilter",
        valueGetter: (params) => params.data?.status || "-",
        width: 100,
        headerClass: getHeaderClass,
      },
      {
        field: "prasad",
        headerName: "Prasad",
        filter: "agTextColumnFilter",
        valueGetter: (params) =>
          params.data?.prasad === undefined || params.data?.prasad === null
            ? "-"
            : params.data.prasad
            ? "Yes"
            : "No",
        width: 80,
        headerClass: getHeaderClass,
      },
      {
        field: "donorRemarks",
        headerName: "Donor Remarks",
        filter: "agTextColumnFilter",
        valueGetter: (params) => params.data?.donorRemarks || "-",
        width: 150,
        headerClass: getHeaderClass,
      },
    ],
    [donations, role, donationsReady] // ✅ donationsReady added to deps
  );

  const onFirstDataRendered = () => {
    setIsFirstLoad(false);
    if (gridRef.current && donors && donors.length > 0) {
      gridRef.current.api.hideOverlay();
    }
  };

  // ✅ bug fix: gridRef.current = params (full object), so must use .api
  const exportToExcel = () => {
    if (!gridRef.current) return;
    gridRef.current.api.exportDataAsCsv({
      fileName: `Donors_export ${getSystemFormattedTimestamp()}.csv`,
    });
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        height: "calc(100vh - 200px)",
      }}
    >
      <Filter
        onFilterChange={handleFilterChange}
        fields={["donorId", "name", "mobile", "pincode", "status", "remarks"]}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "end",
          marginBottom: "10px",
        }}
      >
        <Button
          variant="contained"
          color="error"
          onClick={handleClearAll}
          sx={{ mr: 2 }}
        >
          Clear All Filters
        </Button>
        {role === "superadmin" || role === "admin1" || role === "admin2" ? (
          <Button onClick={exportToExcel} variant="contained" color="primary">
            <DriveFileMoveIcon /> Export
          </Button>
        ) : null}
      </div>

      {/* ✅ phase3: history + merge modals outside ag-grid container */}
      <HistoryModal
        title="Donor Updated History"
        open={historyModalOpen}
        onClose={handleCloseHistory}
        history={selectedHistory}
        donorId={selectedDonorId}
      />

      <ComparisonSelectedModal
        open={comparisonModalOpen}
        onClose={handleComparisonModalClose}
        selectedDonor={sourceDonorForMerge}
        donors={donors}
        onCompare={handleCompareConfirm}
      />

      <CompareDonorsDialog
        open={compareDialogOpen}
        onClose={handleCompareDialogClose}
        sourceDonor={sourceDonorForMerge}
        targetDonor={targetDonorForMerge}
        onMerge={handleMergeConfirm}
        loading={mergeLoading}
      />

      <ManualMergeDialog
        open={mergeResultModalOpen}
        onClose={handleMergeResultClose}
        mergeResult={mergeResult}
      />

      <div
        className="ag-theme-alpine"
        style={{ height: "100%", width: "100%", overflow: "auto" }}
      >
        <AgGridReact
          key="donor-grid"
          ref={gridRef}
          rowData={filteredDonors}
          columnDefs={columnDefs}
          domLayout="autoHeight"
          onGridReady={onGridReady}
          onFirstDataRendered={onFirstDataRendered}
          pagination
          paginationPageSize={10}
          paginationPageSizeSelector={[10, 20, 50]}
          loadingOverlayComponent={AgGridLoader}
          loadingOverlayComponentParams={{
            loadingMessage: "Loading donors, please wait...",
          }}
          onRowDoubleClicked={handleRowDoubleClick}
          onFilterChanged={(params) => params.api.refreshHeader()}
          // ✅ phase3: column state change handlers
          onColumnMoved={(event) => handleColumnChange(event)}
          onColumnPinned={(event) => handleColumnChange(event)}
          onColumnVisible={(event) => handleColumnChange(event)}
          onColumnResized={(event) => handleColumnChange(event)}
          onDragStopped={(event) => handleColumnChange(event)}
          onColumnRowGroupChanged={(event) => handleColumnChange(event)}
          suppressColumnMoveAnimation={false}
          animateRows={true}
        />
      </div>

      <AlertMessage
        title="Donor Delete Alert"
        open={alertMessageOpen}
        setOpen={setAlertMessageOpen}
        message="This donor has donations. You cannot delete this donor."
      />

      <ConfirmationDialog
        open={openConfirm}
        title="Delete Donor"
        message="Are you sure you want to delete this donor?"
        onConfirm={handleDeleteConfirm}
        onCancel={handleCloseConfirm}
      />

      <SnackBarAlert feedback={feedback} onClose={handleCloseFeedback} />
    </div>
  );
};

export default DonorList;